import React, { Suspense } from 'react';
import { useVersion } from '@/versionStrategy';
import V2App from '@/versions/v2';
import V3App from '@/versions/v3';
import LoadingScreen from '@/pages/common/LoadingScreen';
/**
 * App Root — Version Strategy Router
 *
 * Routes to the appropriate version based on src/config/versionConfig.state.ts (via VersionProvider)
 * - v2 (default): Current production version with top navigation
 * - v3: New design with left sidebar navigation
 *
 * Each version is completely self-contained with its own:
 * - Layout (Home.tsx)
 * - Pages
 * - Features
 * - Components (if version-specific)
 */
const App = () => {
  const { version } = useVersion();

  // Select the active version app
  const ActiveVersionApp = version === 'v3' ? V3App : V2App;

  return (
    <Suspense fallback={<LoadingScreen />}>
      <ActiveVersionApp />
    </Suspense>
  );
};

export default App;
